"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SlaGraphIcon() {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "140", height: "98", viewBox: "0 0 140 98" },
        React.createElement("g", { fill: "none" },
            React.createElement("rect", { width: "109", height: "24", fill: "#FBD0D2" }),
            React.createElement("rect", { width: "109", height: "32", y: "29", fill: "#F6D9B4" }),
            React.createElement("rect", { width: "109", height: "33", y: "65", fill: "#D2E8A7" }),
            React.createElement("path", { stroke: "#999", strokeDasharray: "3 3", strokeLinecap: "square", d: "M0 26.5L140 26.5M0 62.5L140 62.5" }),
            React.createElement("g", { stroke: "#878787", transform: "rotate(-180 48 49)" },
                React.createElement("path", { d: "M52,92 L77,3 L52,92 Z", transform: "rotate(-180 64.5 47.5)" }),
                React.createElement("path", { d: "M46,1 C46,1 48,31.3333333 52,92 C48,31.3333333 46,1 46,1 Z", transform: "rotate(-180 49 46.5)" }),
                React.createElement("path", { d: "M41,35 C42.4982768,23.7937296 44.6290823,13.2635173 46,2", transform: "rotate(-180 43.5 18.5)" }),
                React.createElement("path", { d: "M35,2 L41,35 L35,2 Z", transform: "rotate(-180 38 18.5)" }),
                React.createElement("path", { d: "M22,1.5 C30.6666667,1.5 35,1.5 35,1.5 C35,1.5 30.6666667,1.5 22,1.5 Z", transform: "rotate(-180 28.5 1.5)" }),
                React.createElement("path", { d: "M18,25 C19.3333333,17.3333333 20.6666667,9.66666667 22,2 L18,25 Z", transform: "rotate(-180 20 13.5)" }),
                React.createElement("path", { d: "M13,2 L18,25 L13,2 Z", transform: "rotate(-180 15.5 13.5)" }),
                React.createElement("path", { d: "M0,61 L13,1 L0,61 Z", transform: "rotate(-180 6.5 31)" })))));
}
exports.SlaGraphIcon = SlaGraphIcon;
